var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekButton, PeekDialog } from "@piiqtechnologies/ui-components";
import { AccessDeviceTypes, useAnalytics, useCreateAccessDevice, useError, useLoader, useNotification, useRefetch, } from "@piiqtechnologies/ui-lib";
import { Plus as PlusIcon } from "@piiqtechnologies/svg-icons";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import CreateAccessDeviceForm from "./CreateAccessDeviceForm";
import messages from "./messages.i18n";
export const CreateAccessDevice = ({ community }) => {
    const [createAccessDevice, createAccessDeviceResp, isCreatingAccessDevice, errorCreatingAccessDevice] = useCreateAccessDevice();
    const [showModal, setShowModal] = useState(false);
    const { setNotification } = useNotification();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const intl = useIntl();
    const analytics = useAnalytics();
    const toggleShowModal = () => {
        setShowModal(!showModal);
    };
    const onCreateAccessDevice = (_a) => {
        var values = __rest(_a, []);
        const finalValues = Object.assign(Object.assign({}, values), { identifier: values.identifier || `${community._id}-${values.name}`, communityId: community._id });
        values.type === AccessDeviceTypes.CONCIERGE && delete finalValues.manufacturer;
        createAccessDevice(Object.assign({}, finalValues));
    };
    useEffect(() => {
        setLoader(isCreatingAccessDevice, "isCreatingAccessDevice");
        return () => setLoader(false, "isCreatingAccessDevice");
    }, [isCreatingAccessDevice]);
    useEffect(() => {
        if (errorCreatingAccessDevice)
            setError(errorCreatingAccessDevice === null || errorCreatingAccessDevice === void 0 ? void 0 : errorCreatingAccessDevice.message);
    }, [errorCreatingAccessDevice]);
    useEffect(() => {
        if (createAccessDeviceResp) {
            toggleShowModal();
            analytics.track("Access Device Created");
            setNotification(intl.formatMessage(messages.createAccessDeviceSuccess));
            setRefetch();
        }
    }, [createAccessDeviceResp]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekButton, { size: "large", variant: "outlined", color: "info", startIcon: React.createElement(PlusIcon, null), onClick: toggleShowModal, sx: { alignSelf: "center", minWidth: "fit-content" }, "data-testid": "create-access-device-button" }, intl.formatMessage(messages.createAccessDeviceTitle)),
        React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, title: intl.formatMessage(messages.createAccessDeviceTitle), open: showModal, onClose: toggleShowModal, fullWidth: true, "data-testid": "create-access-device-dialog" },
            React.createElement(CreateAccessDeviceForm, { onSubmit: onCreateAccessDevice, community: community }))));
};
export default CreateAccessDevice;
